<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> Credit History
      </template>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Paid_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                <b-button inline variant="warning" @click="so.opt['created_at_ed'] = ''; so.opt['created_at_sd'] = ''">Clear</b-button>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-col md="3">
            <label for="ph_search_opt_type">System</label>
            <b-form-group>
              <c-switch color="info" label size="sm" v-model="so.opt['admin_id']" @change="change" />
            </b-form-group>
          </b-col>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <label for="ph_search_group">Group Name</label>
            <b-button size="sm" id="ph_search_group" :variant="group_name ? 'primary' : 'success'" @click="chainGroup = true">Select Group</b-button>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('group')">Clear</b-button>
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="true" v-model="group_name">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <label for="ph_search_partner">Partner Name</label>
            <b-button size="sm" id="ph_search_partner" :variant="partner_name ? 'primary' : 'success'" @click="chainPartner = true">Select Partner</b-button>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('partner')">Clear</b-button>
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="true" v-model="partner_name">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="4">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" @change="refresh" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <hr>
      <b-row>
        <b-col sm="2" v-if="view_detail !== false">
          <b-badge variant="success">
            TOTAL : {{model.total | dollar}}
          </b-badge>
          <br>
          <b-badge variant="primary">
            System : {{model.system | dollar}}
          </b-badge>
          <br>
        </b-col>

        <b-col :sm="view_detail !== false ? 10 : 12" class="md-10">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='admin_id';so.skt='System'">System</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv || so.sk == 'admin_id'" v-model="so.sv" @keyup.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-input-group size="sm">
            <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
            <!-- <div>
              <b-button v-if="enable_new !== false" size="sm" variant="success" @click="$router.push({ name: 'history.credit', params: { id : 'add' } })"> New Registration </b-button>
            </div> -->
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="created_at" slot-scope="row">
          {{ row.item.created_at | datetime}}
        </template>
        <template slot="admin" slot-scope="row">
          {{row.item.admin ? row.item.admin.username : 'System'}}
        </template>
        <template slot="partner" slot-scope="row">
          {{row.item.partner && row.item.partner.username ? row.item.partner.username : '-'}}
        </template>
        <template slot="group" slot-scope="row">
          {{row.item.group && row.item.group.groupname ? row.item.group.groupname : '-'}}
        </template>
        <template slot="method" slot-scope="row">
          <span> {{row.item.method || '-'}} </span>
          <!-- <b-badge style="cursor:pointer" @click="modal_history(row.item.history)" v-if="row.item.is_paid == false && row.item.total_paid" variant="primary">?</b-badge> -->
        </template>
        <template slot="credit_amount" slot-scope="row">
          <span> {{row.item.credit_amount | dollar}} </span>
          <!-- <b-badge style="cursor:pointer" @click="modal_history(row.item.history)" v-if="row.item.is_paid == false && row.item.total_paid" variant="primary">?</b-badge> -->
        </template>
        <template slot="func" slot-scope="row">
          <!-- <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">Select</b-btn> -->
          <b-btn @click="modal_history(row.item)" size="sm" variant="outline-primary">Select</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
      </b-row>
    </b-card>
    <!-- start modal -->
    <b-modal title="Find then Group and Select" size="xl"  header-bg-variant="info" v-model="chainGroup" @ok="chainGroup = false" ok-only cancel-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
    <!-- start modal -->
    <b-modal title="Find then Partner and Select" size="xl"  header-bg-variant="info" v-model="chainPartner" @ok="chainPartner = false" ok-only cancel-variant="info">
      <partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setPartner"></partner-List>
    </b-modal>
    <!-- start modal -->
    <b-modal title="Detail information" size="x"  header-bg-variant="info" v-model="confirm_payment_history" @ok="confirm_payment_history = false" ok-only cancel-variant="primary">
      <!-- {"purchased_at":"2020-07-30T05:20:58.965844Z","action":"partner payment","pg_name":"f1","pg":"credit","price":10.0} -->
      <table class="table table-sm" v-if="payment_history">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Value</th>
          </tr>
        </thead>
        <!-- {"is_add":false,"invoice_id":"cf22279b-7bbd-406c-b3ef-b0f321786ac7","to":"test_hdh_01","to_credit":0.00,"from":"hdh+partner1+09@f1security.co.kr","from_credit":26.26,"reason":"Completes payment with credit"} -->
        <tbody>
          <tr>
            <th scope="row">Invoice</th>
            <td>
              <a style="cursor:pointer;color:skyblue;" v-if="payment_history.invoice_id" @click="$router.push({ name : 'invoice', params : { invoice_id : payment_history.invoice_id } })">
                {{payment_history.invoice_id}}
              </a>
              <span v-else>-</span>
            </td>
          </tr>
          <tr>
            <th scope="row">From</th>
            <td>
              {{payment_history.from || '-'}}
              ({{payment_history.from_credit | dollar}})
            </td>
          </tr>
          <tr>
            <th scope="row">To</th>
            <td>
              {{payment_history.to || '-'}}
              ({{payment_history.to_credit | dollar}})
            </td>
          </tr>
          <tr>
            <th scope="row">Amount</th>
            <td>
              {{payment_history.credit_amount | dollar}}
            </td>
          </tr>
          <tr>
            <th scope="row">Reason</th>
            <td>
              {{payment_history.reason || '-'}}
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/custom';
import { Api } from '@/service';
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import partnerList from '../../Management/partner/Partner.List'
import groupList from '../../Management/group/Group.List'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: 'id', sv: '', skt: '', opt : {}, adv: false
});

export default {
  components: { DatePicker, vSelect, cSwitch, partnerList, groupList },
  props : ["auto_refresh", "enable_new", "view_detail", "group_id", "partner_id"],
  name : "paymentList",
  data: () => ({
    confirm_payment_history : false,
    payment_history : '',
    loading : false,
    group_name : '',
    chainGroup : false,
    partner_name : '',
    chainPartner : false,
    custom,
    codes,
    datepicker,
    so : default_opt(),
    model : { total : 0, system : 0 },
    sync : { interval : 15, stop : false, th : undefined },
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let f = [
        { key: 'id', thStyle: 'width: 5%', sortable: true, label: 'No.' },
        { key: 'created_at', thStyle: 'width: 15%', sortable: true, label: 'Date' },
        { key: 'admin', thStyle: 'width: 15%', sortable: true, label: 'Admin(System)'},
        { key: 'partner', thStyle: 'width: 15%', sortable: true, label: 'Partner'},
        { key: 'group', thStyle: 'width: 15%', sortable: true, label: 'Group'},
        { key: 'credit_amount', thStyle: 'width: 10%', sortable: false, label: 'Amount' },
        { key: 'func', sortable: false, label: 'More' },
      ]
      return f;
    },
  },
  methods: {
    modal_history(item) {
      if(!item.credit_info) { return this.$toastr.e("no have more information") }
      try { this.payment_history = JSON.parse(item.credit_info) }
      catch (e) { console.debug(e); this.payment_history = item.credit_info }
      this.payment_history.credit_amount = item.credit_amount
      this.confirm_payment_history = true;
      console.log("payment history load", history.length)
    },
    clearChain(type) {
      if(!type) { return this.$toastr.w("require", "clear type") }
      switch (type) {
        case 'partner':
          delete this.so.opt.partner_id
          this.partner_name = '';
          this.chainPartner = false;
          break;
        case 'group':
          delete this.so.opt.group_id
          this.group_name = '';
          this.chainGroup = false;
          break;
        default:
          break;
      }
    },
    setPartner(item) {
      console.log("partner info", item.username, item.id)
      this.so.opt['partner_id'] = item.id
      this.partner_name = item.username;
      this.chainPartner = false;
      this.refresh()
    },
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.refresh()
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        // this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'credit_amount'){
        return { name : k, value : parseFloat(v, 10), op : '=' };
      }
      if((k.length > 3 && k.substring(k.length - 3) == "_id") || [].indexOf(k) > -1) {
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true' || (k.length > 2 && k.substring(0, 2) == "is")) {
        return { name : k, value : v === "false" || v === false ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.th) { clearTimeout(this.th); this.th = undefined; }
      if(!this.th && this.sync.stop) { this.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.group_name = ''; this.partner_name = ''; this.refresh(); },
    refresh() { if(!this.loading && this.$refs._list) { this.$refs._list.refresh(); } },
    getRowCount () { return this.so.totalRows || 0; },
    change($event) { if($event == true || $event == false) { this.so.opt['admin_id'] = $event; this.refresh(); } },
    load(ctx = {}) {
      this.loading = true;
      let so = {
        target : 'history.credit', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk == 'admin_id') {
        so.body.or.push({ name : this.so.sk, value : 0, op : '=' });
        so.body.or.push({ name : this.so.sk, value : 0, op : 'is null' });
      } else if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 10), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" } }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 10), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" } }
              break;

            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.name == 'admin_id' || cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
        if(this.so.opt['admin_id']) {
          so.body.or.push({ name : 'admin_id', value : 0, op : '=' });
          so.body.or.push({ name : 'admin_id', value : 0, op : 'is null' });
        }
      }
      return Api.Manager(so).then(rs => {
        this.loading = false
        this.so.totalRows = rs.total; return rs.body;
      }).catch(e => {
        this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
      })
    },
    summary() {
      Api.Manager({ target : 'history.credit', cmd : 'summary', body : { ts : new Date().getTime() } })
        .then(rs => { this.model = Object.assign(this.model, { total : rs.body.total, system : rs.body.system }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item) {
      console.log(item);
      if(this.view_detail === false) { this.$emit("select", item); }
      else { this.$router.push({ name : 'payment', params : { id : item.id } }); }
    },
  },
  created() { console.log('payment_history.vue', 'created'); },
  destroyed() { console.log('payment_history.vue', 'destroyed'); },
  mounted() {
    console.log('payment_history.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}
</script>
